import {ModalDrawer} from "../../ui";
import {WalletAssetMergeType} from "../../types";
import {useMatchChain, useModal} from "../../hooks";
import {AlphaAvatar} from "ui";
import {Button} from "../index";
import TokenSend from "../TokenSend";
import {NATIVE_TOKEN_ADDRESS} from "../../config";
import {FormattedMessage, useIntl} from "react-intl";
import {NumberFormatter} from "../../utils";

export default function TokenDetail({
    onClose,
    token
                                    }:{
    onClose:()=>void
    token:WalletAssetMergeType
}){
    const {list:chainList} = useMatchChain()
    const modal = useModal()
    const chain = chainList?.find((m)=>m.id.toString() === token.chain_id)
    const onSend = ()=>{
        modal.show((props)=>{
            return <TokenSend onClose={()=>{
                props.close()
                onClose()
            }} onBack={props.close} zIndex={props.zIndex} token={token}/>
        })
    }
    const intl = useIntl()
    return <ModalDrawer isOpen title={intl.formatMessage({
        id: "tokenDetails"
    })} onClose={onClose}>
        <div className={`matchid-token-detail`}>
            <div className={`matchid-token-main`}>
                <div className={`matchid-token-info`}>
                    <div className={`matchid-token-logo`}>
                        {token.icon ? <img src={token.icon} alt={token.symbol} className={`matchid-token-icon`}/> :
                            <AlphaAvatar className={`matchid-token-icon`} size={48} name={token.symbol||token.name||''}/>}
                        {chain?.iconUrl &&
                            <img src={chain.iconUrl} alt={chain.name} className={`matchid-token-chain`}/>}
                    </div>
                    <div className={`matchid-token-name`}><NumberFormatter value={token.balance} tFixNum={10}/> {token.symbol}</div>
                </div>
                {token.address.toLowerCase()!=NATIVE_TOKEN_ADDRESS && <div className={`matchid-token-contract`}>
                    <div className={"matchid-token-contract-title"}>Contract address</div>
                    <div className={"matchid-token-contract-address"}>{token.address}</div>
                </div>}
            </div>
            <Button size={"lg"} block highlight onClick={onSend}><FormattedMessage id={"send"}/></Button>
        </div>
    </ModalDrawer>
}